import { e2eeModel } from 'APP/model/model';
import Entities from 'STORE';
import { SecretGroup } from 'STORE/Groups/SecretGroup/SecretGroup';

export const getActiveSecretGroupAccessRequests = async (groupId: string): Promise<void> => {
  try {
    const requests = await e2eeModel.getActiveSecretChatAccessRequests(groupId);

    const group = Entities.GroupsStore.getGroupById(groupId);

    if (!group || !(group instanceof SecretGroup)) {
      return;
    }

    group.setDevicesRequests(requests);
  } catch (error) {
    return;
  }
};
